import type { ZoneCountry, ZoneCountryFilter } from '@/types/api';

// The markets a zone can belong to. Mirrors the Country select options of the
// Notion "Hunting zones database" (the source of truth) and the backend
// api.country_code enum, in the same order.
export const ZONE_MARKETS: readonly ZoneCountry[] = [
  'FR',
  'IT',
  'BE',
  'CH',
  'DE',
  'ES',
  'NL',
  'AT',
  'LU',
  'CZ',
] as const;

// Every value the `country` query param accepts: the markets plus the "no
// country" sentinel. Derived from ZONE_MARKETS so the two can never drift —
// a market missing here is silently dropped when a filter URL is read back.
export const ZONE_COUNTRY_FILTER_VALUES: readonly ZoneCountryFilter[] = ['unset', ...ZONE_MARKETS];

export const COUNTRY_LABELS: Record<ZoneCountry, string> = {
  FR: 'France',
  IT: 'Italy',
  BE: 'Belgium',
  CH: 'Switzerland',
  DE: 'Germany',
  ES: 'Spain',
  NL: 'Netherlands',
  AT: 'Austria',
  LU: 'Luxembourg',
  CZ: 'Czechia',
};

export const COUNTRY_FLAGS: Record<ZoneCountry, string> = {
  FR: '🇫🇷',
  IT: '🇮🇹',
  BE: '🇧🇪',
  CH: '🇨🇭',
  DE: '🇩🇪',
  ES: '🇪🇸',
  NL: '🇳🇱',
  AT: '🇦🇹',
  LU: '🇱🇺',
  CZ: '🇨🇿',
};
